// extracted by mini-css-extract-plugin
export default {"container":"YkexqI","divider":"RrNe8W"};